// seoConfig.js
const seoConfig = {
    "/": {
        title: "Rotiey - Fresh Food Delivered",
        description: "Order your favorite meals with Rotiey. Fresh, fast, and tasty food delivered to your doorstep.",
        keywords: ["Rotiey", "food delivery", "online food", "fresh meals"],
    },
    "/about": {
        title: "About Us - Rotiey",
        description: "Learn more about Rotiey and our mission to deliver happiness with food.",
        keywords: ["about Rotiey", "our story", "food service"],
    },
    "/blog": {
        title: "Blog - Rotiey",
        description: "Read the latest food tips, recipes, and updates from Rotiey.",
        keywords: ["Rotiey blog", "food recipes", "cooking tips"],
    },
    "/blog/:Id": {
        title: "Blog Details - Rotiey",
        description: "Read this detailed blog article from Rotiey.",
        keywords: ["Rotiey blog", "food insights", "recipes"],
    },
    "/cart": {
        title: "My Cart - Rotiey",
        description: "View and manage the items in your Rotiey shopping cart.",
        keywords: ["Rotiey cart", "checkout", "order food"],
    },
    "/sign-in": {
        title: "Sign In - Rotiey",
        description: "Sign in to your Rotiey account to order your favorite meals.",
        keywords: ["login Rotiey", "sign in food order"],
    },
    "/my-address": {
        title: "My Addresses - Rotiey",
        description: "Manage your delivery addresses for faster checkout with Rotiey.",
        keywords: ["Rotiey address", "delivery location"],
    },
    "/my-order": {
        title: "My Orders - Rotiey",
        description: "Track and manage all your Rotiey food orders in one place.",
        keywords: ["Rotiey orders", "track food", "order history"],
    },
    "/profile": {
        title: "My Profile - Rotiey",
        description: "Manage your account details and preferences in Rotiey.",
        keywords: ["Rotiey profile", "account settings"],
    },
    "/contact": {
        title: "Contact Us - Rotiey",
        description: "Have questions? Contact Rotiey support team today.",
        keywords: ["contact Rotiey", "customer support"],
    },
    "/checkout": {
        title: "Checkout - Rotiey",
        description: "Complete your Rotiey order securely and quickly.",
        keywords: ["Rotiey checkout", "order payment"],
    },
    "/address": {
        title: "Order Address - Rotiey",
        description: "Add or select an address for your Rotiey order.",
        keywords: ["Rotiey address", "delivery details"],
    },
    "/order-confirm": {
        title: "Order Confirmation - Rotiey",
        description: "Your Rotiey order is confirmed. Get ready for delicious food!",
        keywords: ["Rotiey confirm", "order placed"],
    },
    "/menu": {
        title: "Menu - Rotiey",
        description: "Explore the Rotiey menu and order your favorite dishes.",
        keywords: ["Rotiey menu", "food items", "order food"],
    },
    "/product-detail": {
        title: "Product Details - Rotiey",
        description: "View detailed information about this Rotiey product.",
        keywords: ["Rotiey product", "meal details"],
    },
    "/support": {
        title: "Support - Rotiey",
        description: "Need help? Get support from Rotiey’s customer service team.",
        keywords: ["Rotiey support", "customer help"],
    },
    "/partner": {
        title: "Partner with Us - Rotiey",
        description: "Join Rotiey as a partner and grow your business with us.",
        keywords: ["Rotiey partner", "restaurant partner", "food delivery partner"],
    },
};

export default seoConfig;
